import React from 'react';
import {
  FormGroup,
  FormControl,
  HelpBlock,
  ButtonGroup,
  Button,
} from 'react-bootstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import '../../../public/css/passwordRecovery.css';
import { updatePassword, getToken } from '../../../api/api';
import PasswordSuccess from './PasswordSuccess';
import { get } from 'lodash';
import ApiError from './ApiError';
import PasswordStrengthInfo from '../PasswordStrengthInfo';
import defaultMsg from '../../../translations/lang/en-US.json';
import { MdLoaderTheme } from '../../common/Loading';

class ResetPassword extends React.Component {
  initialState(props) {
    return {
      newPassword: '',
      confirmPassword: '',
      passwordRequiredError: false,
      invalidPasswordError: false,
      confirmPasswordRequiredError: false,
      confirmPasswordMustMatchError: false,
      passwordRessetSuccess: false,
      lavuToGoName: get(props, 'params.rname', false),
      tokenId: false,
      jwt: false,
      apiErrors: [],
      requestingForPasswordUpdate: false,
      passwordNote: true,
    };
  }

  constructor(props) {
    super(props);
    this.state = this.initialState(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleConfirmChange = this.handleConfirmChange.bind(this);
    this.isValidPassword = this.isValidPassword.bind(this);
    this.unsetFormErrors = this.unsetFormErrors.bind(this);
    this.setToken = this.setToken.bind(this);
    this.enablePasswordNote = this.enablePasswordNote.bind(this);
    this.disablePasswordNote = this.enablePasswordNote.bind(this);
    this.setToken();
  }

  setToken() {
    getToken().then(response => {
      this.setState({
        tokenId: get(response, 'data.tokenId', false),
        jwt: get(response, 'data.jwt', false),
      });
    });
  }

  handlePasswordChange(e) {
    this.setState({
      newPassword: e.target.value,
      confirmPassword: '',
      apiErrors: [],
      passwordNote: true,
    });

    this.unsetFormErrors();
  }

  handleConfirmChange(e) {
    this.unsetFormErrors();
    if (this.state.newPassword.length > 0 && this.isValidPassword()) {
      this.setState({
        confirmPassword: e.target.value,
        apiErrors: [],
        passwordNote: false,
      });
    } else {
      this.setState({
        confirmPassword: '',
        passwordRequiredError: true,
        apiErrors: [],
      });
    }
  }

  isValidPassword() {
    return /^(?=.*\d)(?=.*[@#\-_$%^&+=Â§!\?])(?=.*[a-z])(?=.*[A-Z])[0-9A-Za-z@_!-]{8,15}$/.test(
      this.state.newPassword
    );
  }

  isConfirmed() {
    return (
      this.state.newPassword.length > 0 &&
      this.state.newPassword === this.state.confirmPassword
    );
  }

  getValidationStateForPassword() {
    if (this.isValidPassword()) {
      return 'success';
    } else if (this.state.newPassword.length > 0) {
      return 'warning';
    }
    return null;
  }

  getValidationStateForConfrimPassword() {
    if (this.isConfirmed()) {
      return 'success';
    } else if (this.state.confirmPassword.length > 0) {
      return 'warning';
    }
    return null;
  }

  unsetFormErrors() {
    this.setState({
      passwordRequiredError: false,
      confirmPasswordRequiredError: false,
      invalidPasswordError: false,
      confirmPasswordMustMatchError: false,
    });
  }

  enablePasswordNote() {
    this.setState({
      passwordNote: !this.isValidPassword(),
    });
  }

  disablePasswordNote() {
    this.setState({
      passwordNote: false,
    });
  }

  handleFormSubmit() {
    const isValidPassword = this.isValidPassword(),
      isConfirmedPassword = this.isConfirmed();

    if (isValidPassword && isConfirmedPassword) {
      const { newPassword, confirmPassword, tokenId, jwt } = this.state;
      const { resetToken } = this.props.params;
      this.setState({
        requestingForPasswordUpdate: true,
        apiErrors: [],
      });
      updatePassword({
        newPassword,
        confirmPassword,
        tokenId,
        jwt,
        resetToken,
      })
        .catch(error => {
          this.setState({
            apiErrors: [
              this.props.intl.formatMessage({
                id: 'serverNotResponding',
                defaultMessage: defaultMsg.serverNotResponding,
              }),
            ],
            requestingForPasswordUpdate: false,
          });
        })
        .then(response => {
          const apiResponse = get(response, 'data.DataResponse', {});
          if (apiResponse !== null && apiResponse.Status === 'S') {
            this.setState({
              passwordRessetSuccess: true,
              requestingForPasswordUpdate: false,
            });
          } else if (
            apiResponse !== null &&
            apiResponse.msg &&
            apiResponse.Status === 'F'
          ) {
            this.setState({
              apiErrors: [apiResponse.msg],
              requestingForPasswordUpdate: false,
            });
          } else {
            this.setState({
              apiErrors: [
                this.props.intl.formatMessage({
                  id: 'invalidToken',
                  defaultMessage: defaultMsg.invalidToken,
                }),
              ],
              requestingForPasswordUpdate: false,
            });
          }
        });
    } else {
      const { newPassword, confirmPassword } = this.state;
      this.setState({
        passwordRequiredError: newPassword.length < 1,
        confirmPasswordRequiredError: confirmPassword.length < 1,
        invalidPasswordError: newPassword.length > 0 && !isValidPassword,
        confirmPasswordMustMatchError:
          confirmPassword.length > 0 && !isConfirmedPassword,
      });
    }
  }

  render() {
    return (
      <div className="reset-password-sub-container">
        {this.state.passwordRessetSuccess ? (
          <PasswordSuccess lavuToGoName={this.state.lavuToGoName} />
        ) : (
          <div>
            {this.state.tokenId === false ? (
              <div className="text-center">
                <MdLoaderTheme size={25} />
              </div>
            ) : (
              <div>
                <h4 className="modal-title olo-client-theme-color text-center">
                  <FormattedMessage
                    id="resetPassword"
                    defaultMessage={defaultMsg.resetPassword}
                  />
                </h4>
                <div className="font-medium login-help-block text-center">
                  <FormattedMessage
                    id="passwordStrengthInformation"
                    defaultMessage={defaultMsg.passwordStrengthInformation}
                  />
                </div>
                <FormGroup
                  controlId="newPassword"
                  validationState={
                    this.state.passwordRequiredError ||
                    this.state.invalidPasswordError
                      ? 'error'
                      : this.getValidationStateForPassword()
                  }
                  bsSize="large"
                >
                  <FormControl
                    type="password"
                    value={this.state.newPassword}
                    placeholder={this.props.intl.formatMessage({
                      id: 'newPassword',
                      defaultMessage: defaultMsg.newPassword,
                    })}
                    onChange={e => this.handlePasswordChange(e)}
                    onFocus={this.enablePasswordNote}
                    onBlur={this.disablePasswordNote}
                    className="font-medium"
                  />

                  <FormControl.Feedback />
                  {this.state.passwordRequiredError ||
                  this.state.invalidPasswordError ? (
                    <HelpBlock className="font-medium">
                      <FormattedMessage
                        id="invalidPasswordMessage"
                        defaultMessage={defaultMsg.invalidPasswordMessage}
                      />
                    </HelpBlock>
                  ) : null}

                  <PasswordStrengthInfo />
                </FormGroup>

                <FormGroup
                  controlId="confirmPassword"
                  validationState={
                    this.state.confirmPasswordRequiredError ||
                    this.state.confirmPasswordMustMatchError
                      ? 'error'
                      : this.getValidationStateForConfrimPassword()
                  }
                  bsSize="large"
                >
                  <FormControl
                    type="password"
                    value={this.state.confirmPassword}
                    placeholder={this.props.intl.formatMessage({
                      id: 'confirmPassword',
                      defaultMessage: defaultMsg.confirmPassword,
                    })}
                    onChange={e => this.handleConfirmChange(e)}
                    onFocus={this.disablePasswordNote}
                    className="font-medium"
                  />
                  <FormControl.Feedback />
                  {this.state.confirmPasswordRequiredError ? (
                    <HelpBlock className="font-medium">
                      <FormattedMessage
                        id="blankConfirmationPassword"
                        defaultMessage={defaultMsg.blankConfirmationPassword}
                      />
                    </HelpBlock>
                  ) : null}
                  {this.state.confirmPasswordMustMatchError ? (
                    <HelpBlock className="font-medium">
                      <FormattedMessage
                        id="confirmPasswordErrorMessage"
                        defaultMessage={defaultMsg.confirmPasswordErrorMessage}
                      />
                    </HelpBlock>
                  ) : null}
                </FormGroup>
                {this.state.apiErrors.length > 0 ? (
                  <ApiError errors={this.state.apiErrors} />
                ) : null}

                <ButtonGroup justified>
                  <Button
                    onClick={
                      this.state.requestingForPasswordUpdate
                        ? null
                        : this.handleFormSubmit
                    }
                    className="full-width"
                    bsStyle="success"
                    bsSize="large"
                  >
                    {this.state.requestingForPasswordUpdate ? (
                      <FormattedMessage
                        id="submiting"
                        defaultMessage={defaultMsg.submiting}
                      />
                    ) : (
                      <FormattedMessage
                        id="submitButton"
                        defaultMessage={defaultMsg.submitButton}
                      />
                    )}
                  </Button>
                </ButtonGroup>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

ResetPassword.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(ResetPassword);



// WEBPACK FOOTER //
// ./src/views/auth/passwordreset/ResetPassword.jsx